import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import dayjs from "dayjs";
import { FC } from "react";

import TimestampField from "../../../components/TimestampField";
import { isEndingWithin24Hours } from "../utils";

const useStyles = makeStyles((theme) => ({
  oldTime: {
    color: theme.palette.grey[500],
  },
  endingWithin24Hours: {
    color: theme.palette.warning.main,
  },
}));

const ReservationsTime: FC<any> = (props) => {
  const classes = useStyles({});
  const reservation = props.record;

  const isOldTime = (time: Date) => dayjs(time).isBefore(dayjs());

  return (
    <div>
      {reservation && reservation.firstSlotTime ? (
        <TimestampField
          {...props}
          cellClassName={clsx({
            [classes.endingWithin24Hours]: isEndingWithin24Hours(reservation.firstSlotTime.toDate()),
            [classes.oldTime]: isOldTime(reservation.firstSlotTime.toDate()),
          })}
        />
      ) : null}
    </div>
  );
};

export default ReservationsTime;
